<template>
    <div>
        <v-dialog
    v-model="add_klent_dialog"
    max-width="450"
    @click:outside="close_klent"
  >
    <v-card>

    <v-toolbar
        color="primary"
        dark
        >
        <v-toolbar-title>Добавление нового клиента</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
        <v-btn icon dark @click="close_klent">
            <v-icon>mdi-close</v-icon>
        </v-btn>
        </v-toolbar-items>
    </v-toolbar>

<v-form ref="forma" v-model="valid">
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="forma.nom_klent"
                label="Имя клиента"
                required
                :rules="[v => !!v || 'Введите имя клиента']"
                @focus="scanner()"
                @blur="scanner()"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
                <v-select
                :items="Valutaho"
                v-model="forma.id_kurb"
                :rules="[v => !!v || 'Выберите валюту']"
                item-text="text"
                item-value="value"
                label="Валюта клиента"
                hide-details="auto"
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-text-field
                @focus="scanner()"
                @blur="scanner()"
                v-model="forma.dolg"
                label="Начальный долг"
                :rules="summaRules"
                hide-details="auto"
                ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="forma.tel"
                label="Телефон клиента"
                required
                :rules="phoneRules"
                @focus="scanner()"
                @blur="scanner()"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
                <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="forma.date"
                    label="Дата рождения"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="forma.date"
                  :active-picker.sync="activePicker"
                  :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                  min="1950-01-01"
                  @change="save_date"
                  hide-details="auto"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12">
                <v-switch
                v-model="forma.bonus_switch"
                inset
                label="Бонусная карта"
                hide-details="auto"
              ></v-switch>
            </v-col>

            <v-col cols="12" v-if="forma.bonus_switch">
                <v-select
                :items="bonus_namud"
                v-model="forma.id_bonus_namud"
                :rules="[v => !!v || 'Выберите тип бонусной карты']"
                item-text="text"
                item-value="value"
                label="Тип бонусной карты"
                hide-details="auto"
                ></v-select>
            </v-col>

            <v-col cols="12" v-if="forma.bonus_switch">
                <v-text-field
                @focus="scanner()"
                @blur="scanner()"
                v-model="forma.nomer_karta"
                label="Номер бонусной карты"
                required
                :rules="[v => !!v || 'Введите номер бонусной карты']"
                hide-details="auto"
                ></v-text-field>
            </v-col>

            <v-col cols="12">
                <!-- button save -->
                <v-btn
                block
                color="primary"
                class="mr-4"
                @click="save_klent"
                :loading="loading"
                :disabled="!valid"
                >
                Сохранить
                </v-btn>

            </v-col>



          </v-row>
        </v-container>
      </v-card-text>
    </v-form>

      <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>

    </v-card>
  </v-dialog>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    data() {
        return {
            loading: false,
            valid:false,
            snack: false,
            snackColor: '',
            snackText: '',

            add_klent_dialog: true,

            activePicker: null,

            menu: false,

            Valutaho: [
                { text: 'TJS', value: 1},
                { text: 'USD', value: 2},
                { text: 'RUB', value: 3}
              ],

              bonus_namud: [
                { text: 'Обычный', value: 1},
                { text: 'По каджой покупки', value: 2},
                { text: 'Месячное', value: 3}

              ],

              phoneRules: [
                v => !!v || 'Введите номер телефона',
                v => (v && /^\d+$/.test(v)) || 'Неверный формат номера телефона',
                v => (v && v.length == 9) || 'Неверный формат номера телефона',
            ],

            summaRules: [
                v => !!v || 'Введите начальный долг',
                v => (v && /^\d*(\.\d{1,2})?$/.test(v)) || 'Неверный формат начального долга',
            ],


            forma:{
                nom_klent: '',
                id_kurb: 0,
                dolg: 0,
                tel:'',
                date: null,
                bonus_switch: false,
                id_bonus_namud: 0,
                nomer_karta: '',

            }

        }
    },

    watch: {
      menu (val) {
        val && setTimeout(() => (this.activePicker = 'YEAR'))
      },
    },

    methods: {
        addKlent() {
            this.add_klent_dialog = true;
        },

        save_date (date) {
        this.$refs.menu.save(this.forma.date)
        },

        scanner(){
            this.$emit('scanner')
        },


        save_klent(){

            if(this.forma.bonus_switch==false){
                this.forma.id_bonus_namud = 0;
                this.forma.nomer_karta = '';
                this.forma.bonus = 0;
            }else{
                this.forma.bonus = 1;
            }

            this.loading = true;
            axios.post('/api/save_klent', this.forma,
            {
                headers: {
                    "Content-type": "application/json"
                }
            })
            .then(response => {
                    if(response.data.status){
                        this.loading = false;
                        this.snack = true
                        this.snackColor = 'success'
                        this.snackText = response.data.message
                        this.forma = {
                            nom_klent: '',
                            id_kurb: 0,
                            dolg: 0,
                            tel:'',
                            date: null,
                            bonus_switch: false,
                            id_bonus_namud: 0,
                            nomer_karta: '',
                        }
                        setTimeout(() => {
                            this.snack = false;
                        }, 2000);

                        this.$emit('save_klent_success')

                    }else{
                        this.loading = false;

                        setTimeout(() => {
                            this.snack = false;
                        }, 2000);
                    }
                })
                .catch(error => {
                    this.loading = false;

                   // this.$emit('save_klent_error')
                    this.snack = true
                    this.snackColor = 'error'
                    this.snackText = error.response.data.message

                        setTimeout(() => {
                            this.snack = false;
                        }, 2000);
                });

        },

        close_klent(){
            this.$emit('close_klent')
        }
    }

}
</script>

<style>

</style>





